export default __webpack_public_path__ + "static/media/me3_logo_black_NEW.d2807d55.png";